<div class="flex items-center pl-3.5 pr-1">
  <span class="grow text-surface-300 cursor-default">Themes</span>
  <a
    pButton
    [routerLink]="['design-tokens', 'themes', 'create']"
    type="button"
    class="!text-surface-400 hover:!bg-surface-700"
    severity="secondary"
    text
    rounded
  >
    <i pButtonIcon class="{{ PrimeIcons.PLUS }}"></i>
  </a>
</div>
@for (group of allThemesGroupedByBrand(); track group.brandName) {
  <div class="pl-4 text-sm text-surface-400 font-light">
    {{ group.brandName }}
  </div>
  <ul class="list-none flex-col">
    @for (theme of group.themes; track theme.id) {
      <li class="flex items-center">
        <a
          class="grow !block px-4 py-2 max-w-40 truncate"
          [class.!text-amber-300]="theme.isSelected"
          [class.active-link]="theme.isSelected"
          [routerLink]="['design-tokens', 'themes', theme.id]"
        >
          {{ theme.name }}
        </a>

        <div>
          <p-menu
            #themeMenu
            [model]="theme.menuItems"
            [popup]="true"
            appendTo="body"
          />
          <p-button
            type="button"
            [icon]="PrimeIcons.ELLIPSIS_V"
            text
            severity="secondary"
            size="small"
            styleClass="hover:!bg-surface-700"
            rounded
            (onClick)="themeMenu.toggle($event)"
          />
        </div>
      </li>
    }
  </ul>
}
<div class="pb-2"></div>
